import React from 'react';
import styles from '../../../../../../custom/style.module.css';
import MyDocument from './Doc';
import { Font, pdf } from '@react-pdf/renderer';
import { CustomButton } from 'custom/components';
import { DownloadIcon } from 'custom/constants';
import http from 'utils/http';
import cookies from 'utils/cookies';
import { toast } from 'react-toastify';

Font.register({
  family: 'Nunito',
  fonts: [
    { src: '../../../../../../assets/fonts/Nunito-Regular.ttf', },
    {
      src: '../../../../../../assets/fonts/Nunito-Regular.ttf',
      fontWeight: 600 
    }
  ]
});

const getFilename = (file_name, period, billingFields) => {
  console.log('getFilename inside Invoice.js called with file_name:', file_name);
  if (!file_name) return '';
  if(!billingFields?.exclude_disc){
    file_name = file_name+ 'DIS';
  }
  if(period === 'first'){
    file_name = file_name + '-01';
  } else if(period === 'second'){  
    file_name = file_name + '-02';
  }
  console.log('file_name', file_name);
  return file_name;
};

const sanitizeFilename = (name = 'invoice.pdf') => {
  const cleaned = String(name).replace(/[\\/:*?"<>|]/g, '-').trim();
  return cleaned || 'invoice.pdf';
};

const resolveDownloadName = (fallbackName, contentDisposition) => {
  const safeFallback = sanitizeFilename(fallbackName.endsWith('.pdf') ? fallbackName : `${fallbackName}.pdf`);
  if (!contentDisposition) return safeFallback;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match && utf8Match[1]) {
    try {
      return sanitizeFilename(decodeURIComponent(utf8Match[1]));
    } catch (e) {
      return safeFallback;
    }
  }

  const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (plainMatch && plainMatch[1]) {
    return sanitizeFilename(plainMatch[1]);
  }

  return safeFallback;
};

const triggerBrowserDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', sanitizeFilename(filename));
  document.body.appendChild(link);
  link.click();

  // Fallback cleanup for browsers that delay synthetic clicks after async work.
  setTimeout(() => {
    if (document.body.contains(link)) {
      document.body.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  }, 1000);
};

const Invoice = (props) => {
  const handleDownload = async () => {
    try {
      // Prepare filename
      console.log('invoice_info', props.invoice_info);
      const filename = getFilename(props.filename || props.file_name, props.searchFields?.period, props.billingFields) || 'invoice';
      
      if (props.useOldLogic) {
        // Render PDF directly on the frontend
        const doc = (
          <MyDocument
            invoice_no={filename.endsWith('.pdf') ? filename : filename + '.pdf'}
            flightdata={props.flightdata}
            daylogdata={props.daylogdata}
            monthlogdata={props.monthlogdata}
            invoiceData={props.invoiceData}
            dayContractData={props.dayContractData}
            monthContractData={props.monthContractData}
            invoice_info={props.invoice_info}
            airlineCode={props.airlineCode}
            cont_item={props.cont_item}
            searchFields={props.searchFields}
            billingFields={props.billingFields}
            oneOff={props.oneOff}
          />
        );
        const asPdf = pdf([]);
        asPdf.updateContainer(doc);
        const blob = await asPdf.toBlob();

        triggerBrowserDownload(blob, filename.endsWith('.pdf') ? filename : filename + '.pdf');
        return;
      }

      const payload = {
        invoice_info: props.invoice_info,
        searchFields: props.searchFields,
        billingFields: props.billingFields,
        filename: filename,
        isItemized: String(props.title || '').toLowerCase().includes('itemized'),
        company_name: cookies.get('company_name') || '',
      };
      
      // Send to backend for PDF generation and password protection
      const response = await http.post('/add_invoice_password', payload, { responseType: 'blob' });
      
      // Download password-protected PDF
      const pdfBlob = response?.data instanceof Blob
        ? response.data
        : new Blob([response.data], { type: 'application/pdf' });
      const disposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
      const downloadName = resolveDownloadName(filename, disposition);
      triggerBrowserDownload(pdfBlob, downloadName);
      
      // Show email-password modal after 1 second
      setTimeout(() => {
        props.handleEmailPassword();
      }, 1000);
    } catch (error) {
      console.error('Error generating password-protected PDF:', error);
      toast.error('Error generating password-protected PDF');
    }
  };

  return (
    <CustomButton
      variant='contained'
      size='small'
      className={`${styles.dBlock} ${styles.mr2}`}
      disabled={props.progress < 100}
      onClick={handleDownload}
    >
      <DownloadIcon className={`${styles.whiteSvg} ${styles.mr1} ${styles.btnIcons}`} /> {props.title}
    </CustomButton>
  );
};

export default Invoice;